import {Tag} from "primereact/tag";
import type {ReactNode} from "react";

import logoLight from "../images/logo_value_marktdaten.png";
import logoDark from "../images/logo_value_marktdaten_dark.png";
import {selectAppRoleLabel} from "../redux/envSlice";
import {useRevaSelector} from "../redux/revaHooks";
import {selectDarkTheme} from "../redux/themeSlice";

/** Card classes of the login page; the password reset page uses the same card (#19351). */
export const LOGIN_CARD_CLASS =
    "LoginForm bg-surface-0 dark:bg-surface-900 p-6 mt-8 shadow-2 rounded-border w-full lg:w-6/12";

/** Logo, product name and instance tag at the top of the login card, optionally with a subtitle below. */
export default function LoginCardHeader({subtitle}: {subtitle?: ReactNode}) {
    const isDarkTheme = useRevaSelector(selectDarkTheme);
    const roleLabel = useRevaSelector(selectAppRoleLabel);

    return (
        <div className="text-center mb-8">
            <img src={isDarkTheme ? logoDark : logoLight} className="App-logo m-auto mb-8" width="50%" alt="LOGO" />
            <div className="text-surface-900 dark:text-surface-0 text-xl leading-[normal] font-medium mb-4 flex items-center justify-center">
                Real Estate Valuation Assistant
                {roleLabel && <Tag value={roleLabel} className="ml-4" />}
            </div>
            {subtitle && <div className="text-surface-600 dark:text-surface-300">{subtitle}</div>}
        </div>
    );
}
